<template>
  <div class="column-title">
    <span class="column-title-text" :style="'color:'+titleColor ">{{ title }}</span>
    <router-link class="column-link" v-if="link!==null&&link!==''" :to="link" :style="'color:'+linkColor ">
      {{ linkText }}<i class="el-icon-d-arrow-right"></i></router-link>
    <div class="column-split-line" :style="'background:'+splitLineColor "></div>
  </div>
</template>

<script>
export default {
  name: "ColumnTitle",
  props: {
    title: {
      type: String,
      default: ''
    },
    titleColor: {
      type: String,
      default: 'black'
    },
    link: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: 'More'
    },
    linkColor: {
      type: String,
      default: '#0094ff'
    },
    splitLineColor: {
      type: String,
      default: '#0094ff'
    },
  }
}
</script>

<style scoped>
.column-title {
  padding: 16px 0;
}

.column-title-text {
  font-size: 24px;
  font-weight: bold;
}

.column-split-line {
  height: 4px;
  width: 40px;
}

.column-link {
  text-decoration: none;
  margin-left: 4px;
}
</style>